import React, { useEffect, useRef, useState } from "react";
import FileUploader from "../ResumeSelection/ResumesUpload";
import {
  Badge,
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Modal,
  Paper,
  Radio,
  Slide,
  Toolbar,
  Typography,
  Tooltip,
  Stack,
  Checkbox,
  List,
  ListSubheader,
  useMediaQuery,
  IconButton,
  ButtonGroup,
  Avatar,
  useTheme,
  TextField,
  ListItemButton,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { Phone, Email, GitHub, LinkedIn, Edit, Verified, CheckBox, Close, VerifiedRounded } from "@mui/icons-material";
import 'react-phone-number-input/style.css';
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import {
  candidateSelectedResumeAction,
  creteNotificationAction,
  getCandidateDetailAction,
  getPrimaryResumeDetailsAction,
  selectedCandidateAction,
  updatePrimaryResumeAction,
} from "../../redux/action";

import { userSelector } from "../../user-redux/selector";

import axios from "axios";
import {
  FaGithub,
  FaLinkedinIn,
  FaSkype,
  FaStackOverflow,
} from "react-icons/fa";
import introImg from "../../../Components/images/intro.png";
import { useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import moment from "moment";
import ResumePdfViewer from "./ResumePdfViewer";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Key from "../../../clientVariables.json";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { myCandidatesSelector } from "../redux/selector";
import { getActiveCandidatesAction } from "../../redux/action";
import { useDispatch } from "react-redux";
import CandidateDetailsView from "../../candidatesPage/CandidateDetailsView";
import PhoneInput, {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  formatPhoneNumber,
  formatPhoneNumberIntl,
  parsePhoneNumber
} from 'react-phone-number-input';
const ResumesView = ({ activeCandidate, onProfileView }) => {
  const { candidateResumesList, candidateDetails } =
    useSelector(myCandidatesSelector);
  const { user } = useSelector(userSelector);
  const { primaryResumeDetails } = useSelector(appSelector);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const openFileUploadRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedEmail, setEditedEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const dispatch = useDispatch();
  const [open, setopen] = useState("resume_view");
  const [loading, setLoading] = useState(false);

  const [resumes, setResumes] = useState([]);
  const [selectedResume, setSelectedResume] = useState(null);
  const [resumesRefresh, setResumesRefresh] = useState(false);
  const theme = useTheme();
  //const { primaryResumeDetails } = useSelector(appSelector);
  const [resumeCheckedLength, setResumeCheckedLength] = useState(0);
  const [resumesChecked, setResumesChecked] = useState([]);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedButton, setSelectedButton] = useState("resume_view"); // Default is 'resume'
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs")); // Very small mobile devices
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm")); // Regular mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktop = useMediaQuery(theme.breakpoints.up("md")); // Desktops and larger
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  const [primaryResumeData, setPrimaryResumeData] = useState(null);
  const [editedTitle, setEditedTitle] = useState("");
  const [editedPhone, setEditedPhone] = useState("");
  const [editedLinkedIn, setEditedLinkedIn] = useState("");
  const [editedGitHub, setEditedGitHub] = useState("");
  const [editedSkype, setEditedSkype] = useState("");
  const [editedStackOverflow, setEditedStackOverflow] = useState("");
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const topBarStyles = {
    padding: "10px",
    borderRadius: "4px",
    margin: "5px 5px 5px 5px",
    border: "none",
  };

  const paperStyles1 = {
    borderRadius: "8px",
    height: "100%",
    overflow: "hidden",
    padding: "0",
    display: "flex",
    flexDirection: "column",
  };

  const paperStyles0 = {
    borderRadius: "8px",
    height: "100vh",
    overflow: "scroll",
    padding: "1px",
  };

  const handleView = (view) => {
    setopen(view);
    setSelectedButton(view);
    // Perform additional actions based on the view (e.g., fetching data)
    if (view === "profile_view") {
      dispatch(getCandidateDetailAction(candidateDetails?.candidate_id));
    }
  };

  const [selectedResumeIndex, setSelectedResumeIndex] = useState(
    primaryResumeDetails?.id
  );

  useEffect(() => {
    setPrimaryResumeData(primaryResumeDetails);
    //console.log("Primary Resume Data:", primaryResumeDetails);
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight); // Update height on resize
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getPrimaryResumeDetails();
  }, [candidateDetails]);

  const getPrimaryResumeDetails = async () => {
    const updateData = {
      candidate_id: candidateDetails?.candidate_id,
    };
    const response = await dispatch(getPrimaryResumeDetailsAction(updateData));

    // Log the response to see the fetched data
    //console.log("Fetched Primary Resume Details:", response);

    // If needed, update your state or perform other actions here
  };

  const sendNotification = async () => {
    const notifyData = {
      user_id: user?.candidate_id,
      notifiedto: user?.user_id,
      notificationDescription: "Updated the Primary Resume ",
      notificationSubject: "Resume Updated",
      notificationType: "",
      job_id: "",
      candidate_name: user?.candidate_name,
      job_title: "",
    };
    await dispatch(creteNotificationAction(notifyData));
  };
  const updateprimaryResume = async (resume_id) => {
    setLoading(true);
    const updatedData = {
      candidate_id: user?.candidate_id,
      resumeid: resume_id,
      primary: 1,
    };

    const response = await dispatch(updatePrimaryResumeAction(updatedData));

    if (response?.success === 1 && response?.data?.affectedRows > 0) {
      //console.log("Primary Resume Updated Successfully:", response);

      await getPrimaryResumeDetails();
      // console.log("Updated Primary Resume Details:", primaryResume); // Log the updated resume

      handleOpenSnackbar(response?.messege, "success");
      getCandidateResumeList();
      setLoading(false);
    } else {
      handleOpenSnackbar("Failed to update primary resume", "error");
      setLoading(false);
    }
  };

  const resumeCheckedHandler = (isCheck, resumeId) => {
    const resumeData = resumes.filter((data) => resumeId === data.resume_id);

    let extractedResumeId;
    if (resumeData.length > 0) {
      extractedResumeId = resumeData[0].resume_id;
    }
    if (isCheck) {
      setResumeCheckedLength(resumeCheckedLength + 1);
      setResumesChecked((prevChecked) => [...prevChecked, extractedResumeId]);
    } else {
      if (!isCheck) {
        setResumeCheckedLength(resumeCheckedLength - 1);
        setResumesChecked((prevChecked) =>
          prevChecked.filter((id) => id !== extractedResumeId)
        );
      }
    }
  };

  const getCandidateResumeList = async () => {
    try {
      const candidateId = user?.candidate_id;
      if (candidateId !== null) {
        const response = await axios.post(
          `${Key.domain}/common/get_candidate_resumes_list`,
          { candidate_id: user?.candidate_id, user_id: user?.id }
        );
        if (response.status === 200) {
          const resumesData = response?.data?.data;
          if (resumesData?.length > 0) {
            await setResumes(resumesData);
            await setSelectedResume(resumesData[0]);
            const primaryResume = resumesData.find(
              (resume) => resume.isPrimary === 1
            );
            setSelectedResume(primaryResume || resumesData[0]); // Display primary if exists, else first resume
            dispatch(
              candidateSelectedResumeAction(primaryResume || resumesData[0])
            );
          } else {
            setResumes([]);
            setSelectedResume(null);
            setOpenFileUpload(true);
          }
        } else {
          console.log("No data in response");
        }
      } else {
        console.log("No candidate ID found");
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleFileChange = (item) => {
    setSelectedResume(item);
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        if (candidateDetails?.candidate_id) {
          const response = await axios.post(
            `${Key.domain}/common/get_candidate_resumes_list`,
            {
              candidate_id: candidateDetails.candidate_id,
              user_id: candidateDetails?.user_id,
            }
          );
          const resumeData = response.data.data;
          setResumes(resumeData);
          const primaryResume = resumeData.find(
            (resume) => resume.isPrimary === 1
          );
          if (primaryResume) {
            setSelectedResume(primaryResume);
          } else {
            setSelectedResume(resumeData[0]);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetch();
    // Important: don't refetch when only `candidateDetails` object fields change.
    // Clicking `Profile` dispatches `getCandidateDetailAction`, which updates `candidateDetails`
    // and was unintentionally resetting `selectedResume`.
  }, [candidateDetails?.candidate_id, candidateDetails?.user_id, resumesRefresh]);

  const popupsHandler = (msg, severity) => {
    if (msg) {
      handleOpenSnackbar(msg, severity);
      if (msg === "Resume added successfully") {
        setResumesRefresh(true);
      }
    }
  };

  const closeResumeParserModal = (isClose) => {
    setOpenFileUpload(!isClose);
    setResumesRefresh(isClose);
  };
  const paperStyles = {
    borderRadius: "8px",
    height: "100vh", // Adjust based on your header/footer height
    overflow: "auto",
  };



  const handleEditClick = () => {
    let resume = selectedResume;
    if ((!resume || !resume.resume_id) && resumes && resumes.length > 0) {
      resume = resumes[0];
      setSelectedResume(resume);
    }
    if (!resume || !resume.resume_id) {
      handleOpenSnackbar("No resume available to edit.", "error");
      return;
    }
    setIsEditing(true);
    setEditPopupOpen(true);
    setEditedTitle(resume?.application_title || "");
    setEditedPhone(resume?.home_phone || "");
    setEditedLinkedIn(resume?.linkedin_url || candidateDetails?.linkedin_url || "");
    setEditedGitHub(resume?.github || candidateDetails?.github || "");
    setEditedSkype(resume?.skype_id || candidateDetails?.skype_id || "");
    setEditedStackOverflow(resume?.stack_overflow || candidateDetails?.stack_overflow || "");
  };
  const handleSave = async () => {
    const candidateId = candidateDetails?.candidate_id || selectedResume?.candidate_id;

    if (!selectedResume?.resume_id) {
      handleOpenSnackbar("No resume selected to update.", "error");
      return;
    }
    if (!candidateId) {
      handleOpenSnackbar("No candidate found for update.", "error");
      return;
    }
    if (!editedTitle) {
      handleOpenSnackbar("Job Title is required.", "error");
      return;
    }
    if (editedPhone && phoneError) {
      handleOpenSnackbar(phoneError, "error");
      return;
    }
    if (editedPhone && !isValidPhoneNumber(editedPhone)) {
      handleOpenSnackbar("Please enter a valid phone number", "error");
      return;
    }

    try {
      setLoading(true);

      const updateData = {
        application_title: editedTitle,
        home_phone: editedPhone,
        linkedin_url: editedLinkedIn,
        github_url: editedGitHub,
        skype_id: editedSkype,
        stackoverflow_url: editedStackOverflow
      };

      const response = await axios.put(
        `${Key.domain}/candidate/update-resume-details/${candidateId}/${selectedResume.resume_id}`,
        updateData,
      );

      if (response.data?.success) {
        // Fetch the updated resume from backend to ensure all fields are fresh
        const updatedResumeResp = await axios.post(
          `${Key.domain}/common/get_candidate_resumes_list`,
          { candidate_id: candidateId, user_id: user?.id }
        );
        if (updatedResumeResp.status === 200 && Array.isArray(updatedResumeResp.data?.data)) {
          const updatedResume = updatedResumeResp.data.data.find(
            r => r.resume_id === selectedResume.resume_id
          );
          if (updatedResume) {
            setSelectedResume(updatedResume);
          }
        }
        await dispatch(getActiveCandidatesAction(user?.id, 1, 20));
        popupsHandler("Profile details updated successfully");
        setIsEditing(false);
        setEditPopupOpen(false);
        await dispatch(getCandidateDetailAction(user?.candidate_id));
        await getCandidateResumeList();
      } else {
        const errorMessage = response.data?.message || "Failed to update profile";
        handleOpenSnackbar(errorMessage, "error");
        console.error('Backend error updating profile:', response.data);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      handleOpenSnackbar(
        error.message || "Failed to update profile due to network or unexpected error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditPopupOpen(false);
    setEditedTitle(selectedResume?.application_title || "");
    setEditedPhone(selectedResume?.home_phone || "");
    setEditedLinkedIn(selectedResume?.linkedin_url || "");
    setEditedGitHub(selectedResume?.github || "");
    setEditedSkype(selectedResume?.skype_id || "");
    setEditedStackOverflow(selectedResume?.stack_overflow || "");
  };

  const handleEmailChange = (e) => {
    setEditedEmail(e.target.value);
    setEmailError("");
  };
  const formatPhoneNumber = (value) => {
    if (!value) return value;
    return value;
  };

  const handlePhoneChange = (value) => {
    setEditedPhone(value);

    if (!value) {
      setPhoneError(""); // No error if phone is blank (optional)
      return;
    }

    try {
      const phoneNumber = parsePhoneNumber(value);
      // if (!phoneNumber) {
      //   setPhoneError("Invalid phone number");
      //   return;
      // }

      const nationalNumber = phoneNumber.nationalNumber;

      if (nationalNumber.length > 10) {
        setPhoneError("Phone number cannot exceed 10 digits after country code");
        return;
      }

      if (nationalNumber.length < 10) {
        setPhoneError("Please enter exactly 10 digits after country code");
        return;
      }

      if (!isValidPhoneNumber(value)) {
        setPhoneError("Invalid phone number");
        return;
      }

      setPhoneError(""); // Valid number, clear error
    } catch (error) {
      setPhoneError("Invalid phone number format");
    }
  };

  const emailLower = (selectedResume?.email_address || "N/A").toLowerCase();
  const isEmailLong = emailLower.length > 25; // adjust threshold if needed

  const isValidString = (v) =>
    v !== undefined &&
    v !== null &&
    typeof v === "string" &&
    v.trim().length > 0 &&
    v.trim().toLowerCase() !== "null";


  return (
    <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Add Resume toolbar — fixed, does not scroll */}
      {resumes?.length > 0 && (
        <Box sx={{ flexShrink: 0, mb: 1 }}>
          <Paper elevation={2} sx={{ width: "100%", borderRadius: "8px" }}>
            <Toolbar
              sx={{
                minHeight: "48px !important",
                py: 0,
                bgcolor: "#fff",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", sm: "space-between" },
              }}
            >
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={() => setOpenFileUpload(true)}
                sx={{
                  textTransform: "none",
                  backgroundColor: "#1565c0",
                  height: "30px",
                  boxShadow: "none",
                }}
              >
                <AddCircleOutlineRoundedIcon fontSize="small" />
                &nbsp;Resume
              </Button>

              <Box sx={{ flexGrow: 1 }} />

              <Box sx={{ display: primaryResumeDetails ? "block" : "none" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    marginRight: "5px",
                    color: "#666666",
                  }}
                >
                  #{selectedResume?.resume_id} - {selectedResume?.full_name} -{" "}
                  {selectedResume?.application_title}
                </Typography>
              </Box>

              <Box sx={{ flexGrow: 1 }} />
            </Toolbar>
          </Paper>
        </Box>
      )}

      <Grid container rowSpacing={0} columnSpacing={1} sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        <Grid item xs={12} sm={12} md={3} lg={3} sx={{ height: "100%", minHeight: 0 }}>
          <Paper
            elevation={2}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            {resumes?.length > 0 && (
              <Toolbar
                sx={{
                  pl: { sm: 2 },
                  pr: { xs: 1, sm: 1 },
                  minHeight: "48px !important",
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography variant="body1">My Resumes</Typography>
                </Box>
              </Toolbar>
            )}

            <Divider sx={{ margin: 0 }} />

            {/* Primary Resume — fixed, does not scroll */}
            <Box sx={{ flexShrink: 0 }}>
              <List
                subheader={
                  <ListSubheader component="div" id="nested-list-subheader" sx={{ bgcolor: "background.paper", lineHeight: "36px" }}>
                    Primary Resume
                    <VerifiedRounded
                      sx={{
                        color: "#ff9800",
                        height: "18px",
                        width: "18px",
                        ml: 1,
                      }}
                    />
                  </ListSubheader>
                }
                disablePadding
              >
                {true && (
                  <ListItemButton
                    sx={{ borderBottom: "1px solid #ddd" }}
                    key={primaryResumeDetails?.id}
                    selected={selectedResumeIndex == primaryResumeDetails?.id}
                  >
                    <div
                      style={{ width: "100%", padding: "5px" }}
                    // onClick={() =>
                    //   resumeClickHandler(
                    //     primaryResumeDetails,
                    //     primaryResumeDetails.id
                    //   )
                    // }
                    >
                      <p
                        style={{
                          fontSize: "0.85rem",
                          color: "rgba(0,0,0,0.7)",
                          fontWeight: 600,
                          margin: 0,
                          display: "flex",
                        }}
                      >
                        <span
                          className="over-text"
                          style={{ minWidth: "200px" }}
                        >
                          {primaryResumeDetails?.full_name}
                        </span>
                      </p>
                      <p
                        style={{
                          fontSize: "12px",
                          margin: 0,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            minWidth: 0,                // allow flex child to shrink
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Role: {primaryResumeDetails?.application_title || 'N/A'}
                        </span>

                      </p>
                      <p
                        style={{
                          fontSize: '12px',
                          margin: 0,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          className="rol"
                          style={{
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Experience: {primaryResumeDetails?.total_experience} years
                        </span>

                        <span
                          style={{
                            marginLeft: 'auto',        // pushes date to the right side
                            whiteSpace: 'nowrap',
                            color: '#757575',
                          }}
                        >
                          {primaryResumeDetails?.created
                            ? moment(primaryResumeDetails.created).fromNow()
                            : 'N/A'}
                        </span>
                      </p>
                    </div>
                  </ListItemButton>
                )}
              </List>
              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: 14,
                  px: 2,
                  pb: 1,
                  pt: 0.5,
                }}
              >
                All Resumes
              </Typography>
            </Box>

            {/* All Resumes list — scrollable only */}
            <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden" }}>
              {resumes?.length > 0 &&
                [...resumes]
                  .sort((a, b) => {
                    const aPrimary = Number(a?.isPrimary) === 1 ? 1 : 0;
                    const bPrimary = Number(b?.isPrimary) === 1 ? 1 : 0;
                    return bPrimary - aPrimary;
                  })
                  .map((resume, index) => {
                  const isPrimary = Number(resume?.isPrimary) === 1;
                  return (
                  <React.Fragment key={resume?.resume_id ?? index}>
                    <ListItemButton
                      key={index}
                      sx={{
                        // boxShadow: "none",
                        // borderRadius: "8px",
                        padding: "0px",
                        mx: 1,
                        position: "relative",
                        overflow: "hidden",
                        backgroundColor:
                          selectedResume?.resume_id === resume?.resume_id
                            ? "rgba(25, 118, 210, 0.08)"
                            : "white",
                        "&:hover": {
                          ".more-icons": { display: "flex" },
                          backgroundColor: "#f5f5f5", // Hover background color for full coverage
                        },
                      }}
                      onClick={() => handleFileChange(resume)}
                      onMouseOver={() => setHoverIndex(index)}
                      onMouseLeave={() => setHoverIndex(null)}
                    >
                      <Grid container>
                        {/* Main Content */}
                        <Grid
                          item
                          xs={12}
                          sx={{
                            p: 1,
                            cursor: "pointer",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            position: "relative",
                          }}
                        >
                          <Stack direction="column" spacing={0.5}>
                            <p
                              style={{
                                fontSize: "0.85rem",
                                color: "rgba(0,0,0,0.7)",
                                fontWeight: 600,
                                margin: 0,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <span
                                className="over-text"
                                onClick={() => handleView("resume_view")}
                              >
                                {resume.full_name}
                              </span>
                              <span
                                style={{
                                  marginLeft: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {isPrimary ? (
                                  <Tooltip
                                    title="Primary Resume"
                                    arrow
                                    placement="top"
                                  >
                                    <VerifiedRounded
                                      sx={{
                                        color: "#ff9800",
                                        height: "18px",
                                        width: "18px",
                                        ml: 1,
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    title="Add to Primary"
                                    arrow
                                    placement="top"
                                  >
                                  </Tooltip>
                                )}
                              </span>
                            </p>

                            <p
                              style={{
                                fontSize: '12px',
                                margin: 0,
                                display: 'flex',
                              }}
                            >
                              <span
                                className="rol"
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Role: {resume?.application_title || 'N/A'}
                              </span>
                            </p>
                            <Box
                              sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr auto', // left fills, right hugs
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              {/* Left: Experience (ellipsizes) */}
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: 12,
                                  minWidth: 0,               // <-- lets it shrink
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Experience:{' '}
                                {resume.total_experience.includes('+')
                                  ? resume.total_experience
                                  : `${resume.total_experience} years`}
                              </Typography>

                              {/* Right: Date (flush right) */}
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  pl: 2,
                                  whiteSpace: 'nowrap',
                                  color: '#757575',
                                  justifySelf: 'end',        // <-- pins to right of the grid
                                }}
                              >
                                {resume.created
                                  ? moment(resume.created).fromNow()
                                  : moment('2022-03-31T06:26:04.138Z').fromNow()}
                              </Typography>
                            </Box>


                          </Stack>
                        </Grid>
                      </Grid>
                    </ListItemButton>

                    <Divider sx={{ my: 1 }} />
                  </React.Fragment>
                  );
                })}
            </Box>
          </Paper>
        </Grid>

        <Grid item sm={12} md={9} sx={{ height: "100%", minHeight: 0, overflow: "hidden" }}>
          <Box
            sx={{
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              pr: 0.5,
            }}
          >
            <Paper
              elevation={3}
              sx={{
                p: 2,
                display: "flex",
                border: "1px solid rgb(224, 230, 247)",
                borderRadius: 2,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                width: "100%",
                mb: 1,
              }}
            >
              {/* Left Section: Candidate Details */}
              <Grid item xs={12} md={8}>
                <Box sx={{ position: "relative" }}>
                  <Button
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      minWidth: "auto",
                      padding: 1,
                      zIndex: 1,
                      color: isEditing ? "#4caf50" : "black"
                    }}
                    onClick={handleEditClick}
                  >
                    {isEditing ? <CheckBox /> : <ModeEditOutlineOutlinedIcon />}
                  </Button>
                  {/* Avatar & Candidate Info */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 3, mb: 2 }}>
                    <Avatar
                      src={selectedResume?.image ? `${Key.aws_bucket_profile}/attachments/user_${selectedResume?.uid}/profileimages/${selectedResume?.image}` : null}
                      alt={selectedResume?.first_name || candidateDetails?.candidate_name || "Candidate Name"}
                      sx={{
                        width: "130px",
                        height: "130px",
                        fontSize: "25px",
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                        border: "3px solid white",
                      }}
                    />
                    <Box>
                      <Typography variant="h6" sx={{ color: "rgb(5, 38, 78)", fontWeight: 600 }}>
                        {selectedResume?.full_name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "gray" }}>
                        {selectedResume?.application_title || "Job Title"}
                      </Typography>
                      {/* Contact Info */}
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1 }}>
                        {isValidString(selectedResume?.email_address) ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Email sx={{ fontSize: 18, color: "gray" }} />
                            <Typography
                              variant="body2"
                              title={selectedResume?.email_address || "N/A"}
                              sx={{ wordBreak: "break-all" }}
                            >
                              {typeof selectedResume.email_address === "string"
                                ? selectedResume.email_address.toLowerCase()
                                : "N/A"}
                            </Typography>
                            <Verified sx={{ fontSize: 16, color: "green" }} />
                          </Box>
                        ) : ""}

                        {isValidString(selectedResume?.home_phone) ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Phone sx={{ fontSize: 18, color: "gray" }} />
                            <Typography
                              variant="body2"
                              title={selectedResume?.home_phone || "N/A"}
                              sx={{ wordBreak: "break-all" }}
                            >
                              {typeof selectedResume.home_phone === "string"
                                ? selectedResume.home_phone
                                : "N/A"}
                            </Typography>
                            <Verified sx={{ fontSize: 16, color: "green" }} />
                          </Box>
                        ) : ""}
                      </Box>
                    </Box>
                  </Box>
                  {/* Social Icons */}
                  <Box sx={{ display: "flex", gap: 1 }}>
                    {(selectedResume?.linkedin_url || candidateDetails?.linkedin_url) && (
                      <IconButton
                        href={selectedResume?.linkedin_url || candidateDetails?.linkedin_url}
                        target="_blank"
                        sx={{
                          bgcolor: "rgba(0, 0, 0, 0.04)",
                          fontSize: 20,
                          width: 30,
                          height: 30,
                        }}
                      >
                        <FaLinkedinIn />
                      </IconButton>
                    )}
                    {(selectedResume?.github || candidateDetails?.github) && (
                      <IconButton
                        href={selectedResume?.github || candidateDetails?.github}
                        target="_blank"
                        sx={{
                          bgcolor: "rgba(0, 0, 0, 0.04)",
                          fontSize: 20,
                          width: 30,
                          height: 30,
                        }}
                      >
                        <FaGithub />
                      </IconButton>
                    )}
                    {(selectedResume?.skype_id || candidateDetails?.skype_id) && (
                      <IconButton
                        href={selectedResume?.skype_id || candidateDetails?.skype_id}
                        target="_blank"
                        sx={{
                          bgcolor: "rgba(0, 0, 0, 0.04)",
                          fontSize: 20,
                          width: 30,
                          height: 30,
                        }}
                      >
                        <FaSkype />
                      </IconButton>
                    )}
                    {(selectedResume?.stack_overflow || candidateDetails?.stack_overflow) && (
                      <IconButton
                        href={selectedResume?.stack_overflow || candidateDetails?.stack_overflow}
                        target="_blank"
                        sx={{
                          bgcolor: "rgba(0, 0, 0, 0.04)",
                          fontSize: 20,
                          width: 30,
                          height: 30,
                        }}
                      >
                        <FaStackOverflow />
                      </IconButton>
                    )}
                  </Box>
                  {/* Button Group (Resume/Profile) */}
                  <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    // mt: 2,
                    // mb: 2,
                    width: "100%"
                  }}>
                    <ButtonGroup
                      variant="contained"
                      sx={{
                        borderRadius: "8px",
                        overflow: "hidden",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                        width: "fit-content"
                      }}
                    >
                      <Button
                        onClick={() => handleView("resume_view")}
                        sx={{
                          textTransform: "none",
                          fontSize: "14px",
                          padding: "8px 24px",
                          backgroundColor: selectedButton === "resume_view" ? "#0077B5" : "white",
                          color: selectedButton === "resume_view" ? "white" : "black",
                          fontWeight: 500,
                          borderRight: "1px solid #ccc",
                          "&:hover": {
                            backgroundColor: selectedButton === "resume_view" ? "#005A8C" : "#E0E0E0",
                          },
                        }}
                      >
                        📄 Resume
                      </Button>
                      <Button
                        onClick={() => handleView("profile_view")}
                        sx={{
                          textTransform: "none",
                          fontSize: "14px",
                          padding: "8px 24px",
                          backgroundColor: selectedButton === "profile_view" ? "#0077B5" : "white",
                          color: selectedButton === "profile_view" ? "white" : "black",
                          fontWeight: 500,
                          "&:hover": {
                            backgroundColor: selectedButton === "profile_view" ? "#005A8C" : "#E0E0E0",
                          },
                        }}
                      >
                        👤 Profile
                      </Button>
                    </ButtonGroup>
                  </Box>
                </Box>
              </Grid>

              {/* Right Section: Image */}
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: "auto",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={introImg}
                    alt="Self-introduction video"
                    style={{
                      width: "100%", // Ensure the image fits within bounds
                      height: "auto",
                      opacity: 0.5, // Reduced opacity for the background effect
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "white",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      padding: "10px 20px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "12px",
                      width: "80%",
                    }}
                  >
                    Enhance your profile—video resume feature is on its way
                  </Box>
                </Box>
              </Grid>
            </Paper>

            <Paper elevation={2} sx={{ ...paperStyles1, height: "auto", overflow: "visible" }}>
              {open === "resume_view" ? (
                <ResumePdfViewer
                  resume_id={selectedResume?.resume_id}
                  file_name={selectedResume?.filename}
                />
              ) : open === "profile_view" ? (
                <CandidateDetailsView
                  candidateDetails={candidateDetails}
                  resume_id={selectedResume?.resume_id}
                />
              ) : (
                <></>
              )}
            </Paper>
          </Box>
        </Grid>
      </Grid>
      <Modal
        open={openFileUpload}
        onClose={() => {
          setOpenFileUpload(false);
          // dispatch(clearRedirect());
        }}
      >
        <Slide
          direction="left"
          in={openFileUpload}
          container={openFileUploadRef.current}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
        //   style={{ transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.27, 1.55)'  }}
        >
          <Paper
            elevation={4}
            style={{
              // padding: 16,
              transition: "opacity 2s ease-in-out",
              ...modalParseStyles,
            }}
          >
            <FileUploader
              check="add_resumes"
              closeResumeParserModal={closeResumeParserModal}
              popupsHandler={popupsHandler}
              primaryResumeData={primaryResumeData}
            />
          </Paper>
        </Slide>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <Dialog open={editPopupOpen} onClose={handleCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Profile</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", mt: 1 }}>
            <TextField
              label="Job Title"
              value={editedTitle}
              onChange={(e) => setEditedTitle(e.target.value)}
              size="small"
              required
              error={!editedTitle}
              helperText={!editedTitle ? "Job Title is required" : ""}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <Box
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: phoneError
                    ? "1.5px solid #d32f2f"
                    : "1.5px solid #c4c4c4",
                  borderRadius: "4px",
                  background: "#fff",
                  height: "50px",
                  transition: "border-color 0.3s",
                  "&:focus-within": {
                    borderColor: "#1976d2",
                  },
                }}
              >
                <Phone sx={{ fontSize: 20, color: "gray", ml: 1, mr: 1 }} />
                <Box
                  sx={{
                    flex: 1,
                    ".PhoneInput": { width: "100%" },
                    ".PhoneInputInput": {
                      width: "100%",
                      height: "48px",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      background: "transparent",
                      boxSizing: "border-box",
                      padding: "0 0 0 0",
                    },
                    ".PhoneInputCountry": {
                      marginRight: "8px",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                    },
                    ".PhoneInputCountrySelect": {
                      height: "48px",
                    },
                  }}
                >
                  <PhoneInput
                    defaultCountry="US"
                    international
                    placeholder="Enter phone number"
                    value={editedPhone}
                    onChange={handlePhoneChange}
                    error={phoneError ? phoneError : undefined}
                  />
                </Box>
              </Box>
            </Box>
            {phoneError && (
              <Typography color="error" variant="caption" sx={{ ml: 7, mb: 1 }}>
                {phoneError}
              </Typography>
            )}
            <TextField
              label="LinkedIn URL"
              value={editedLinkedIn}
              onChange={(e) => setEditedLinkedIn(e.target.value)}
              size="small"
              placeholder="https://www.linkedin.com/in/your-profile"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="GitHub URL"
              value={editedGitHub}
              onChange={(e) => setEditedGitHub(e.target.value)}
              size="small"
              placeholder="https://github.com/your-profile"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Stack Overflow URL"
              value={editedStackOverflow}
              onChange={(e) => setEditedStackOverflow(e.target.value)}
              size="small"
              placeholder="https://stackoverflow.com/users/your-id"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiInputBase-root": { height: "50px" },
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{
          display: 'flex',
          justifyContent: 'space-between',
          px: 8,
          pb: 3,
          pt: 2
        }}>
          <Button
            onClick={handleCancel}
            variant="outlined"
            color="secondary"
            sx={{ width: "120px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            disabled={loading || !editedTitle}
            sx={{ width: "120px" }}
          >
            {loading ? <CircularProgress size={20} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ResumesView;

const modalParseStyles = {
  position: "absolute",
  top: "20%",
  left: "35%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  maxHeight: "70vh",
  overflow: "scroll",
  // p: 4,
};
